<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import CommonLink from '@autobid/ui/components/common/Link.vue'
import { convertTextToSlug } from '@autobid/ui/utils/slugUtils'
import AuctionListItemInfoElement from './AuctionListItemInfoElement.vue'

const auction = inject<PreparedAuctionItem>('auction')

const { locale } = useI18n()
</script>

<template>
  <AuctionListItemInfoElement
    v-if="auction?.department && auction.department.name !== 'online'"
    icon="mdi:location"
  >
    <CommonLink
      underline
      class="flex items-center gap-1"
      :href="`/${locale}/${convertTextToSlug(auction.department.name.toLowerCase())}`"
      @click.stop
    >
      <span class="text-sm"> {{ auction.department.name }} </span>
    </CommonLink>
  </AuctionListItemInfoElement>
</template>
